import moment from 'moment';
import 'moment-timezone';

export const formatMassDateTime = (mass, timeZone) => {
  // Parse the date - it may be in UTC or with timezone offset
  const momentDate = moment(mass.massDate);
  // Convert to the specified timezone if provided, otherwise use the parsed timezone
  const momentDateInTimeZone = timeZone ? momentDate.tz(timeZone) : momentDate;
  const massDate = `${momentDateInTimeZone.format('DD.MM.YYYY')} (${momentDateInTimeZone.format(
    'dddd',
  )})`;

  if (mass.hasHour) {
    return `${massDate} o ${momentDateInTimeZone.format('HH:mm')}`;
  }

  return `${massDate} - bez godziny`;
};
